<span class="badge badge-pedido-status badge-pedido-status-reprovado">
    {{status.nome}}
</span>